import { http } from '../../../api/axios';
import { productlistConfig } from '../../../config';
import { Pagination } from '../../../../models/Pagination';
import { ProductSearchResponseOut } from '../../../store/api';

interface ParameterTypes {
    q?: string;
    scope: string;
    pagination: Pagination;
    filterMap: string;
    loanFormat: string | null;
    enabled?: boolean;
    searchLabel?: string;
    refine?: string | null;
}

export const fetchCatalogueSearchResultProducts = ({
    q,
    scope,
    pagination,
    filterMap,
    loanFormat,
    searchLabel,
    refine
}: ParameterTypes) => {
    const endpoint = productlistConfig().endpointSearch;

    const endpointOpts = {
        loanFormat,
        pathParams: {
            kind: 'products',
            scope
        }
    };
    const params = {
        ...pagination,
        loanFormat: endpointOpts.loanFormat,
        q,
        searchLabel,
        refine
    };

    return http
        .post<ProductSearchResponseOut>(endpoint, filterMap, {
            params,
            pathParams: endpointOpts.pathParams
        })
        .then(response => response.data);
};
